export type Countdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

/**
 * @param timeLeftInMilliSeconds Time left in milliseconds as Unix time stamp
 * @returns An object with values for days, hours, minutes, and seconds left.
 * If given time in the past, it returns undefined
 */
export default (timeLeftInMilliSeconds: number): Countdown | "" => {
  const timeLeftInSeconds = timeLeftInMilliSeconds / 1000;

  const days = Math.floor(timeLeftInSeconds / (3600 * 24));
  const hours = Math.floor((timeLeftInSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((timeLeftInSeconds % 3600) / 60);
  const seconds = Math.floor(timeLeftInSeconds % 60);

  // if there is no time left, then return an empty string
  if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
    return "";
  }

  return { days, hours, minutes, seconds };
};
